import { CurrencyCode } from "#graphql/supergraphEnums";
import { MoneyType } from "../../Money/types";
import {
  getMoneyFromWallet,
  getMoneyFromWalletForExtensionField,
  sumMoneyFromWallet,
} from "../../Wallet/utils";
import { AccountingPayableBatch } from "../adapters/accountingPayableAdapter";
import { PositionRowData } from "../types";

export type TransactionMoneyAmounts = {
  totalAmountPayable: MoneyType;
  amountMarkedPaid: MoneyType;
  amountPaidViaAutomatedPayments: MoneyType;
  amountInCurrentBatch: MoneyType;
  remainingToPay: MoneyType;
};

export const getTransactionMoneyAmounts = (
  batchData: AccountingPayableBatch,
  selectedPositions: PositionRowData[],
): TransactionMoneyAmounts => {
  const entityCurrency = (batchData.entity?.currency?.code as CurrencyCode) || CurrencyCode.Usd;
  const totalAmountPayable = getMoneyFromWallet(batchData.totalAmountPayable, entityCurrency);
  const amountMarkedPaid = getMoneyFromWallet(batchData.amountMarkedPaid, entityCurrency);
  const amountPaidViaAutomatedPayments = getMoneyFromWalletForExtensionField(
    batchData.amountPaidViaAutomatedPayments
      ? { monies: [batchData.amountPaidViaAutomatedPayments] }
      : null,
    entityCurrency,
  );
  const fallbackZero: MoneyType = {
    amount: 0,
    currency: entityCurrency,
    precision: totalAmountPayable.precision,
  };
  const amountInCurrentBatch: MoneyType =
    selectedPositions.length > 0
      ? sumMoneyFromWallet(...selectedPositions.map((p) => p.netPayment))[
          entityCurrency.toLowerCase()
        ] ?? fallbackZero
      : fallbackZero;
  const remainingToPay: MoneyType = {
    amount:
      totalAmountPayable.amount -
      amountMarkedPaid.amount -
      amountPaidViaAutomatedPayments.amount -
      amountInCurrentBatch.amount,
    currency: totalAmountPayable.currency,
    precision: totalAmountPayable.precision,
  };
  return {
    totalAmountPayable,
    amountMarkedPaid,
    amountPaidViaAutomatedPayments,
    amountInCurrentBatch,
    remainingToPay,
  };
};
